require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./hoppla-wie-kommt-man-hier-durch.json") })
        }
      }, "path---hoppla-wie-kommt-man-hier-durch");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---hoppla-wie-kommt-man-hier-durch!./.cache/json/hoppla-wie-kommt-man-hier-durch.json
// module id = 425
// module chunks = 231608221292675